/**
 * 主角姓名池
 * 开局页自定义主角姓名：玩家可从池中随机抽取，也可自行输入。
 * 姓氏 / 名字分开抽取组合（避免整段枚举的重复感），女/男名池分开。
 */

/** 姓氏池 */
const SURNAMES = '范雷葛钱昆罗温林沈顾苏白许江宋唐黎沈安容穆萧陆宁秦柳夏温季顾萧叶张王赵李孙朱黄周'.split('');

/** 女性名字池（单字 + 双字混排） */
const FEMALE_NAMES = [
    // 单字
    '薇', '芸', '秋', '菲', '羽', '也', '潇', '沁', '甜', '月', '弥', '苏', '夏', '钰', '越', '慈',
    '灵', '妙', '盈', '瑛', '捷', '悦', '岚', '晴', '圆', '允', '溪', '辛', '澄', '淼',
    // 双字
    '晓彤', '冰冰', '琳梓', '嘉和', '诗然', '婧仪', '可欣', '琪琪', '祖儿', '清扬', '嘉怡', '遥真',
    '存希', '明羲', '宥仪', '汐儿', '宛萤', '明娜', '丽莎', '安心', '一诺', '安琪', '恩又', '翘楚',
    '怡然', '蓁蓁', '茗心', '云妮', '云开', '若蓁', '安宁',
];

/** 男性名字池（单字 + 双字混排；开局性别自选预留，V1 主角固定女角） */
const MALE_NAMES = [
    // 单字
    '峥', '恪', '畅', '睿', '佑', '弈', '洋', '阳', '博', '谦', '淳', '凯', '宇', '驰', '骁', '铭',
    '尧', '杰', '曜', '昕', '煜', '晖', '锐', '琛', '易', '森', '渡', '琰', '天', '远',
    // 双字
    '嘉树', '志伟', '泽言', '思远', '景行', '沛霖', '博文', '一航', '昱珩', '彦霖', '明昊', '昊然',
    '彦嘉', '一博', '彦博', '皓轩', '奕辰', '沛然', '星宇', '明朗', '嘉乐', '一帆', '新杰', '英杰',
    '俊驰', '一鸣', '宇宁', '家阳', '文韬', '展博', '铭宇',
];

/** 随机选取一个元素 */
function pick<T>(arr: T[]): T {
    return arr[Math.floor(Math.random() * arr.length)];
}

/** 随机生成一个主角姓名（姓氏 + 名字拼合；分开填写的场景请用 `randomPlayerNameParts`） */
export function randomPlayerName(gender: 'male' | 'female'): string {
    const parts = randomPlayerNameParts(gender);
    return parts.surname + parts.given;
}

/** 随机生成姓氏 / 名字两段（建角页三格输入用，2026-10-19） */
export function randomPlayerNameParts(gender: 'male' | 'female'): { surname: string; given: string } {
    return {
        surname: pick(SURNAMES),
        given: gender === 'male' ? pick(MALE_NAMES) : pick(FEMALE_NAMES),
    };
}

/**
 * 由「名字」派生昵称（小助理/亲近的人对主角的称呼）：
 *  - 名字双字 → 直接用名字（如「诗然」→「诗然」）
 *  - 名字单字 → 50% 叠字（如「薇」→「薇薇」）/ 50% 小+名（如「薇」→「小薇」）
 *  - 名字为空 → 空字符串（UI 兜底只叫「姐」）
 */
export function deriveNickname(givenName: string): string {
    if (!givenName) return '';
    if (givenName.length >= 2) return givenName.slice(-2);
    if (givenName.length === 1) return Math.random() < 0.5 ? givenName + givenName : '小' + givenName;
    return '';
}
